import type { MapInfoWindowItemProps } from "./map-info-window-item.type";

import { Typography } from "antd";
import { Link, useLocation } from "react-router";

import { TextEllipsis } from "@/ui/text-ellipsis";

import MapInfoWindowItemIcon from "../map-info-window-item-icon";

import { getMarkerLink } from "./map-info-window-item.helper";

const { Text } = Typography;

const MapInfoWindowItem = ({ marker, strong }: MapInfoWindowItemProps) => {
  const location = useLocation();

  const { name } = marker;
  const link = getMarkerLink(marker, location);
  const text = <TextEllipsis text={name} length={76} />;

  return (
    <div className="map-info-window-item">
      <div className="map-info-window-item-content">
        <MapInfoWindowItemIcon marker={marker} />
        <Text strong={strong}>
          {link ? <Link to={link}>{text}</Link> : text}
        </Text>
      </div>
      {marker.children?.map((child) => (
        <MapInfoWindowItem key={child.key} marker={child} />
      ))}
    </div>
  );
};

export default MapInfoWindowItem;
